import React, { useState } from 'react';
import Button from '../Button';
import Field from '../Field';
import AuthBanner from './AuthBanner';
import authErrorView from './authErrorView';
import { classifyError } from '../../domain/authErrors';
import s from './login.module.css';

// Forgot password.
//
// The confirmation deliberately does not say whether an account exists. Firebase
// collapses "no such user" into a silent success here for the same reason it
// collapses wrong-password into invalid-credential: a reset form that answers
// "no account with that address" is an account-enumeration oracle. So the
// message says what was done, not what was found.

export default function ResetPasswordPanel({ email, onEmailChange, onBack, onSend }) {
  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState(null);

  const view = authErrorView(error, 'reset', onBack);

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    setError(null);
    try {
      await onSend(email);
      setSent(true);
    } catch (err) {
      setError(classifyError(err));
    } finally {
      setSending(false);
    }
  };

  if (sent) {
    return (
      <div className={s.formWrap}>
        <div className={s.formHead}>
          <div className={s.markMedium} />
          <h1 className={s.formTitle}>Check your inbox</h1>
          <p className={s.formLead}>
            If an account exists for {email}, a link to set a new password is on its way.
          </p>
        </div>
        <Button variant="secondary" className={s.submit} onClick={onBack}>
          Back to sign in
        </Button>
      </div>
    );
  }

  return (
    <div className={s.formWrap}>
      <div className={s.formHead}>
        <div className={s.markMedium} />
        <h1 className={s.formTitle}>Reset your password</h1>
        <p className={s.formLead}>We&rsquo;ll email you a link to set a new one.</p>
      </div>

      <form onSubmit={submit} className={s.form}>
        {view.banner ? <AuthBanner title={view.banner.title} body={view.banner.body} /> : null}

        <Field label="Email address" htmlFor="reset-email" required error={view.emailError}>
          <input
            id="reset-email"
            type="email"
            autoComplete="email"
            placeholder="you@studio.com"
            value={email}
            data-error={view.emailError ? 'true' : undefined}
            onChange={(e) => onEmailChange(e.target.value)}
            required
          />
        </Field>

        <Button type="submit" variant="primary" size="lg" loading={sending} className={s.submit}>
          Send reset link
        </Button>
      </form>

      <div className={s.switch}>
        <button className={s.switchButton} onClick={onBack}>Back to sign in</button>
      </div>
    </div>
  );
}
